const config = {
  authKey: "",
  env: "dev",
  cache: true
};
export {
  config
};
